import React, { useState } from 'react';

import RawDsButton from '../DsButton';
import RawDsModal from '../DsModal';

export type DetailAction = {
  key: React.Key;
  label: React.ReactNode;
  variant?: string;
  loading?: boolean;
  disabled?: boolean;
  title?: string;
  onClick?: () => void;
};
type DetailActionListProps = {
  actions?: Array<DetailAction | null | false>;
  note?: React.ReactNode;
  onAction?: (() => void) | null;
};
type DetailActionMenuProps = DetailActionListProps & {
  label?: string;
  triggerLabel?: string;
};
const DsButton = RawDsButton as React.ComponentType<any>;
const DsModal = RawDsModal as React.ComponentType<any>;

export function DetailActionList({ actions = [], note = '', onAction = null }: DetailActionListProps) {
  const visibleActions = actions.filter((action): action is DetailAction => Boolean(action));
  return (
    <>
      <div className="detail-action-menu__list ds-compact-action-menu">
        {visibleActions.map((action) => {
          const button = (
            <DsButton
              variant="ghost"
              block
              className={`detail-action-menu__item${action.variant === 'danger' ? ' detail-action-menu__item--danger' : ''}`}
              loading={action.loading}
              disabled={action.disabled}
              title={action.title}
              onClick={() => {
                onAction?.();
                action.onClick?.();
              }}
            >
              {action.label}
            </DsButton>
          );
          return action.variant === 'danger' ? (
            <div key={action.key} className="detail-action-menu__danger">
              {button}
            </div>
          ) : React.cloneElement(button, { key: action.key });
        })}
      </div>
      {note ? <p className="detail-action-menu__note">{note}</p> : null}
    </>
  );
}

export default function DetailActionMenu({
  actions = [],
  note = '',
  label = '操作',
  triggerLabel = '操作メニューを開く',
}: DetailActionMenuProps) {
  const [open, setOpen] = useState(false);
  const visibleActions = actions.filter(Boolean);

  if (!visibleActions.length) return null;

  return (
    <>
      <DsButton
        variant="ghost"
        size="sm"
        icon
        className="detail-action-menu__trigger"
        aria-label={triggerLabel}
        title={label}
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        <i className="fa-solid fa-ellipsis-vertical" aria-hidden="true" />
      </DsButton>
      <DsModal
        open={open}
        onClose={() => setOpen(false)}
        title={label}
        size="sm"
        bodyClassName="detail-action-menu__body"
      >
        <DetailActionList
          actions={visibleActions}
          note={note}
          onAction={() => setOpen(false)}
        />
      </DsModal>
    </>
  );
}
